import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames/bind';
import subtractDays from 'date-fns/sub_days';
import subtractMonths from 'date-fns/sub_months';

import {
  DataBlocks,
  Menu,
  Button,
  DatePicker,
  I18n,
  Status,
} from 'components';

import { openPopup } from 'actions';

import {
  fetchExpenses,
  updatePeriodStart,
  updatePeriodEnd,
} from '../../actions';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

class ReportPeriod extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeMenuEntry: 0,
    };
  }

  componentDidMount() {
    this.props.actions.fetchExpenses();
  }

  setPeriod = (entry, index) => {
    const { actions } = this.props;

    let periodStart;
    switch (entry.type) {
      case 'day':
        periodStart = new Date();
        break;
      case 'week':
        periodStart = subtractDays(new Date(), 6);
        break;
      case 'two-weeks':
        periodStart = subtractDays(new Date(), 13);
        break;
      case 'month':
        periodStart = subtractMonths(new Date(), 1);
        break;
      default:
        break;
    }
    actions.updatePeriodStart(periodStart);
    actions.updatePeriodEnd(new Date());
    this.setState({ activeMenuEntry: index });
  }

  setPeriodStart = (input) => {
    this.props.actions.updatePeriodStart(input);
    this.setState({ activeMenuEntry: null });
  }

  setPeriodEnd = (input) => {
    this.props.actions.updatePeriodEnd(input);
    this.setState({ activeMenuEntry: null });
  }

  render() {
    const { period, actions, isPorted } = this.props;
    const { activeMenuEntry } = this.state;

    return (
      <DataBlocks.ContentGroup className={cx('component')}>
        <div className={cx('periods')}>
          <span className={cx('periodsTitle')}>
            За последние
          </span>
          <Menu
            className={cx('periodsMenu')}
            entries={[
              { label: 'сутки', type: 'day' },
              { label: 'неделю', type: 'week' },
              { label: 'две недели', type: 'two-weeks' },
              { label: 'месяц', type: 'month' },
            ]}
            idProperty="label"
            activeEntry={activeMenuEntry}
            onEntryClick={this.setPeriod}
          />
        </div>
        <div className={cx('dates')}>
          <div className={cx('dateGroup')}>
            <span className={cx('dateLabel')}>
              С
            </span>
            <DatePicker
              className={cx('datePicker')}
              value={period.start}
              min={subtractMonths(new Date(), 7)}
              max={period.end}
              onChange={this.setPeriodStart}
            />
          </div>
          <div className={cx('dateGroup')}>
            <span className={cx('dateLabel')}>
              До
            </span>
            <DatePicker
              className={cx('datePicker')}
              value={period.end}
              min={period.start}
              max={new Date()}
              onChange={this.setPeriodEnd}
            />
          </div>
        </div>

        {!period.isValid && (
          <Status
            className={['attention', cx('periodErrorMessage')]}
          >
            <I18n path={`detalization.reportPeriod.${period.start && period.end ? 'rangeError' : 'rangeErrorEmpty'}`} />
          </Status>
        )}

        <div className={cx('buttons')}>
          <Button
            className={cx('button')}
            onClick={actions.fetchExpenses}
            disabled={!period.isDirty || !period.isValid}
          >
            <I18n path="detalization.createReport" />
          </Button>

          {!isPorted && (
            <Button
              className={[cx('button'), 'default']}
              onClick={() => actions.openPopup('downloadReport')}
              disabled={!period.isValid}
            >
              <I18n path="detalization.saveReport" />
            </Button>
          )}
        </div>
      </DataBlocks.ContentGroup>
    );
  }
}

function mapStateToProps(state) {
  return {
    isPorted: state.application.isPorted,
    period: state.detalization.period,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      fetchExpenses,
      updatePeriodStart,
      updatePeriodEnd,
      openPopup,
    }, dispatch),
  };
}

ReportPeriod.propTypes = {
  period: PropTypes.object,
  actions: PropTypes.object,
  isPorted: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportPeriod);
